(function () {
    'use strict';

    angular
        .module('app')
        .controller('OrderHistoryController', OrderHistoryController);

    OrderHistoryController.$inject = ['API','$scope',];

    function OrderHistoryController(API, $scope) {
        var vm = this;
        vm.cancel = $scope.$parent.cancel;
        vm.resolve = $scope.$parent.resolve;
        vm.loadingState = {
            'subscriptionOrders': false,
        };

        vm.orders = [];
        vm.orderSize = 3;

        activate();

        function activate() {
            vm.subscriptionId = $scope.placeholders.subscriptionId;
            loadSubscriptionOrders();
        }

        function loadSubscriptionOrders() {
            vm.loadingState.subscriptionOrders = true;
            var promise = API.Order.search({
                fk_subscription_id: vm.subscriptionId,
                sort: '-created',
            }).$promise;

            promise.then(function (response) {
                vm.orders = response.items;
                vm.loadingState.subscriptionOrders = false;
            }, function () {
            });
        }

    }
})();